import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AppMaterialModule } from "../../app.material.module";
import { FormsModule } from "@angular/forms";
import { PropertyGroupViewComponent } from "./property-group-view.component";
import { PropertyGroupViewRoutingModule } from "./property-group-view-routing.module";
import { MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";

@NgModule({
  imports: [
    CommonModule,
    PropertyGroupViewRoutingModule,
    AppMaterialModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
  ],

  declarations: [PropertyGroupViewComponent],
})
export class PropertyGroupViewModule {}
